/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/PurchaseOrder',[
    'jquery',
    'lodash',
    'global/all'
], function($, _, Roc) {
    'use strict';

    var addressType = 'po-billing';
    var viewModel = {};

    // TODO: replace this with mapping to PurchaseOrder.Forms.js
    var forms = {
        purchaseOrder: {
            Fields: [
                {
                "Name": 'Purchase Order Number',
                "Field": '#po-number',
                "Param": 'purchaseOrder.purchaseOrderNumber',
                "Type": 'Text',
                "Validators": [
                    {
                        "Type": 'Custom',
                        fn: isValidPurchaseOrderNumber
                    }
                ]
                },
                {
                    "Name": 'Phone',
                    "Field": '#po-phone',
                    "Param": 'purchaseOrder.phone',
                    "Type": 'Text',
                    "Optional": true
                },
                {
                    "Name": 'Authorized By',
                    "Field": '#po-authorized-by',
                    "Param": 'purchaseOrder.authorizedBy',
                    "Type": 'Text',
                    "Optional": true
                }],
            Validate: true,
            RequestParam: 'purchaseOrder'
        },
        billingAddress: {
            Fields: [
               {
                   "Name": 'First Name',
                   "Field": '#po-billing-first-name',
                   "Param": 'address.firstName',
                   "Type": 'Text'
               },
               {
                   "Name": 'Last Name',
                   "Field": '#po-billing-last-name',
                   "Param": 'address.lastName',
                   "Type": 'Text'
               },
               {
                   "Name": 'Company',
                   "Field": '#po-billing-company',
                   "Param": 'address.company',
                   "Type": 'Text',
                   "Optional": true
               },
               {
                   "Name": 'Address 1',
                   "Field": '#po-billing-address1',
                   "Param": 'address.address1',
                   "Type": 'Text'
               },
               {
                   "Name": 'Address 2',
                   "Field": '#po-billing-address2',
                   "Param": 'address.address2',
                   "Type": 'Text',
                   "Optional": true
               },
               {
                   "Name": 'City',
                   "Field": '#po-billing-city',
                   "Param": 'address.city',
                   "Type": 'Text'
               },
               {
                   "Name": 'State',
                   "Field": '#po-billing-state',
                   "Param": 'address.state',
                   "Type": 'Select'
               },
               {
                   "Name": 'Region',
                   "Field": '#po-billing-region',
                   "Param": 'address.region',
                   "Type": 'Text',
                   "Optional": true
               },
               {
                   "Name": 'Country',
                   "Field": '#po-billing-country',
                   "Param": 'address.country',
                   "Type": 'Select'
               },
               {
                   "Name": 'Zip/Postal Code',
                   "Field": '#po-billing-zip',
                   "Param": 'address.zip',
                   "Type": 'Text',
                   'Optional': true,
                   "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#po-billing-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                      {
                          "Type": 'Zip',
                          "ReferencedField": '#po-billing-country',
                          'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                          'ReferencedValue': 'true',
                          'ReferencedFieldType': 'Select'
                      }
                   ]
               },
               {
                   "Name": 'Phone',
                   "Field": '#po-billing-phone',
                   "Param": 'address.phone',
                   "Type": 'Text'
               },
               {
                   "Name": 'Is Default',
                   "Field": '#po-billing-hdAddressIsDefault',
                   "Param": 'address.isDefault',
                   "Type": 'Hidden',
                   "DefaultValue": 'false'
               }
            ],
            Validate: true
        },
        selectedBillingAddress: {
            Fields: [{
                    "Name": 'Billing address Id',
                    "Field": '#po-billing-hdAddressId',
                    "Param": 'creditCardData.addressId',
                    "Type": 'Hidden',
                    "GetValueMethod": { fn: getSelectedBillingAddressId }
            }],
            Validate: true,
            RequestParam: 'billingAddressId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Please select billing address or create a new one.'
        }
    };

    function isValidPurchaseOrderNumber(number) {
        return number.match(/[a-zA-Z0-9\-\.\, ]+/);
    }

    function getSelectedBillingAddressId() {
        return Roc.UI.getItemId('.' + viewModel.address.btns.btnSelected.cssClass);
    };

    function newAddressFormActive() {
        return $('#po-new-address-form-wrapper').is(':visible');
    };

    function unSelectBillingAddress() {
        Roc.UI.swapButtons(viewModel.address.btns, null);
        selectedBillingAddress(null);
    }

    function getAddressViewModel(addr) {
        addr.btnUseThis = viewModel.address.btns.btnUseThis;
        addr.btnSelected = viewModel.address.btns.btnSelected;
        return addr;
    };

    function addNewAddressEvt() {
        $(document).on('click', '#po-billing-addNewAddress', function () {
            unSelectBillingAddress();
            $('#po-new-address-form-wrapper').show();
            $('#po-select-address-wrapper').hide();
        });
    }

    function cancelAddNewAddressEvt() {
        $(document).on('click', '#po-cancelAddNewAddress', function () {
            $('#po-select-address-wrapper').show();
            $('#po-new-address-form-wrapper').hide();
        });
    }

    function selectedBillingAddress(addressId) {
        $('#po-billing-hdAddressId').val(addressId);
    }

    function useAddressEvt() {
        Roc.UI.btnUseThisClickEvt(viewModel.address.btns, function (addressId) {
            selectedBillingAddress(addressId);
        });
    }

    function baseInit(model) {
        viewModel = {
            addressType: addressType,
            countries: model.countries || {},
            states: model.states || {},
            addressList: model.addresses || {},
            address: {
                btns: {
                    btnUseThis: { cssClass: 'po-useThisBillingAddress', text: 'Use this address' },
                    btnSelected: { cssClass: 'po-selected', text: 'Selected address' }
                }
            },
            prefix: 'po-'
        };
    }

    function loadViewModelDetails() {
        $.each(viewModel.addressList, function (i, addr) {
            getAddressViewModel(addr);
        });
    }

    function bindCheckoutEvents() {
        addNewAddressEvt();
        useAddressEvt();
        cancelAddNewAddressEvt();
        Roc.UI.bindAddressFormEvents(addressType);
    }

    function initCheckout(model) {
        baseInit(model);
        loadViewModelDetails();
        viewModel.forms = forms;
        return viewModel;
    }

    function copyBillingFromShipping(shippingForm) {
        _.forEach(shippingForm.Fields, function (f) {
            var destField = _.find(forms.billingAddress.Fields, { Param: 'address.' + f.Param });
            if (destField) {
                $(destField.Field).val($(f.Field).val()).prop('disabled', true).trigger(Roc.Events.general.CHANGE);
            }
        });
        Roc.UI.updateRegionStateDisplay('po-' + addressType);
    }

    function copyBillingFromAddressBook(addressBookEntry) {
        for (var p in addressBookEntry) {
            if (addressBookEntry.hasOwnProperty(p)) {
                var destField = _.find(forms.billingAddress.Fields, { Param: 'address.' + p });
                if (destField && p !== 'id') {
                    $(destField.Field).val(addressBookEntry[p]);
                    $(destField.Field).prop('disabled', true);
                }
            }
        }
        Roc.UI.updateRegionStateDisplay('po-' + addressType);
    }

    function clearBillingForm() {
        Roc.Forms.clearData(forms.billingAddress, true);
        Roc.UI.updateRegionStateDisplay('po-' + addressType);
    }

    var PurchaseOrder = {
        initCheckout: initCheckout,
        bindCheckoutEvents: bindCheckoutEvents,
        getSelectedBillingAddressId: getSelectedBillingAddressId,
        newAddressFormActive: newAddressFormActive,
        copyBillingFromAddressBook: copyBillingFromAddressBook,
        copyBillingFromShipping: copyBillingFromShipping,
        clearBillingForm: clearBillingForm
        
    };

    Roc.Logger.debug('PurchaseOrder.js Loaded:', PurchaseOrder);

    return PurchaseOrder;

});
